"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _UIAvatar = _interopRequireDefault(require("ui-addon-avatars/UIAvatar"));

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _AssociationsStore = _interopRequireDefault(require("crm_data/associations/AssociationsStore"));

var _CompaniesStore = _interopRequireDefault(require("crm_data/companies/CompaniesStore"));

var _AssociationTypes = require("crm_data/associations/AssociationTypes");

var _generalStore = require("general-store");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _SubjectDependency = _interopRequireDefault(require("crm_ui/flux/dependencies/SubjectDependency"));

var _FormattedName = _interopRequireDefault(require("I18n/components/FormattedName"));

var _CompanyRecord = _interopRequireDefault(require("customer-data-objects/company/CompanyRecord"));

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _StyledMiniProfileHighlight = require("crm_ui/profile/sidebar/highlight/mini/StyledMiniProfileHighlight");

var propTypes = {
  subject: _SubjectType.default,
  company: _propTypes.default.instanceOf(_CompanyRecord.default)
};
var dependencies = {
  company: {
    stores: [_AssociationsStore.default, _CompaniesStore.default],
    deref: function deref(_ref) {
      var subject = _ref.subject,
          subjectId = _ref.subjectId,
          objectType = _ref.objectType;

      if (!subject) {
        return null;
      }

      var company = _AssociationsStore.default.get({
        objectType: objectType,
        objectId: subjectId,
        associationType: _AssociationTypes.CONTACT_TO_COMPANY
      });

      if (!company) {
        return null;
      }

      return _CompaniesStore.default.get(company.get('results').first());
    }
  },
  subject: _SubjectDependency.default
};

var MiniContactHighlight =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(MiniContactHighlight, _Component);

  function MiniContactHighlight() {
    (0, _classCallCheck2.default)(this, MiniContactHighlight);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(MiniContactHighlight).apply(this, arguments));
  }

  (0, _createClass2.default)(MiniContactHighlight, [{
    key: "hasSubtitle",
    value: function hasSubtitle() {
      var _this$props = this.props,
          company = _this$props.company,
          subject = _this$props.subject;
      var jobTitle = (0, _ImmutableModel.getProperty)(subject, 'jobtitle');
      return jobTitle || company;
    }
  }, {
    key: "renderAvatar",
    value: function renderAvatar() {
      var subject = this.props.subject;
      return _react.default.createElement("div", {
        className: "m-left-6 m-right-2 m-top-1"
      }, _react.default.createElement(_UIAvatar.default, {
        email: (0, _ImmutableModel.getProperty)(subject, 'email'),
        fileManagerKey: (0, _ImmutableModel.getProperty)(subject, 'hs_avatar_filemanager_key'),
        size: "sm",
        vid: subject && (0, _ImmutableModel.getId)(subject)
      }));
    }
  }, {
    key: "renderTitle",
    value: function renderTitle() {
      var subject = this.props.subject;
      var firstName = (0, _ImmutableModel.getProperty)(subject, 'firstname');
      var lastName = (0, _ImmutableModel.getProperty)(subject, 'lastname');
      var email = (0, _ImmutableModel.getProperty)(subject, 'email');
      return _react.default.createElement(_StyledMiniProfileHighlight.StyledMiniProfileHighlightTitleTruncate, {
        hasSubtitle: this.hasSubtitle()
      }, _react.default.createElement(_FormattedName.default, {
        givenName: firstName,
        familyName: lastName,
        email: email
      }));
    }
  }, {
    key: "renderSubtitle",
    value: function renderSubtitle() {
      if (!this.hasSubtitle()) {
        return null;
      }

      var subject = this.props.subject;
      var jobTitle = (0, _ImmutableModel.getProperty)(subject, 'jobtitle');
      return _react.default.createElement(_StyledMiniProfileHighlight.StyledMiniProfileHighlightSubtitle, null, jobTitle, this.renderCompanyName(jobTitle));
    }
  }, {
    key: "renderCompanyName",
    value: function renderCompanyName(jobTitle) {
      var company = this.props.company;

      if (!company) {
        return null;
      } else if (!jobTitle) {
        return (0, _ImmutableModel.toString)(company);
      }

      return _react.default.createElement(_FormattedMessage.default, {
        message: "contactHighlight.atCompany",
        options: {
          company: (0, _ImmutableModel.toString)(company)
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_StyledMiniProfileHighlight.StyledMiniProfileHighlight, null, this.renderAvatar(), _react.default.createElement(_StyledMiniProfileHighlight.StyledMiniProfileHighlightDetails, {
        className: "text-left"
      }, this.renderTitle(), this.renderSubtitle()));
    }
  }]);
  return MiniContactHighlight;
}(_react.Component);

MiniContactHighlight.propTypes = propTypes;

var _default = (0, _generalStore.connect)(dependencies)(MiniContactHighlight);

exports.default = _default;
module.exports = exports.default;